import {Card, Nav, NavItem} from "reactstrap";
import {NavLink as RouterNavLink} from "react-router-dom";
import React from "react";

export const AuthNavLinks = () => {
  return(
      <Card className={"height-40 rounded-4 mb-2"}>
          <Nav className={"nav-pill-secondary h-100 mb-0 p-25 rounded-4"} pills fill>
              <NavItem>
                  <RouterNavLink
                      to="/signin"
                      className={({ isActive }) =>
                          `nav-link h-100 rounded-4 ${isActive ? "active" : ""}`
                      }
                  >
                      Sign in
                  </RouterNavLink>
              </NavItem>
              <NavItem>
                  <RouterNavLink
                      to="/signup"
                      className={({ isActive }) =>
                          `nav-link h-100 rounded-4 ${isActive ? "active" : ""}`
                      }
                  >
                      Sign Up
                  </RouterNavLink>
              </NavItem>

          </Nav>
      </Card>

  )
}